var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"nitrozen-badge"}},[_c('div',{staticClass:"nitrozen-badge",class:[_vm.addClass]},[(_vm.icon)?_c('nitrozen-icon',{class:[_vm.addClass],attrs:{"name":_vm.icon,"size":_vm.getIconSize}}):_vm._e(),_c('span',{staticClass:"nitrozen-badge-text"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }